import Select from 'react-select'
import Datetime from 'react-datetime'
import { KTSVG } from '_metronic/helpers'

interface Props {
  saleOrder: any[]
  filter: any
  onChangeFilter: (name: string, value: any) => void
  onClearFilter: () => void
  onSubmit: () => void
}

const Filter: React.FC<Props> = ({
  filter,
  onChangeFilter,
  onClearFilter,
  onSubmit,
  saleOrder,
}) => {
  const saleOrderOptions = saleOrder.map(item => ({
    label: `${item.code} - ${item.division}`,
    value: item.id,
  }))

  return (
    <div
      id='kt_shipping_list_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_shipping_list_filter_toggle'
      data-kt-drawer-close='#kt_shipping_list_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                ค้นหา
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_shipping_list_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              {/* begin:: Sale Order */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Sale Order</div>

                <Select
                  styles={{
                    control: (provided: any, state: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={saleOrderOptions}
                  value={saleOrderOptions.find(item => item.value === filter.saleOrderId) ?? null}
                  onChange={(e: any) => onChangeFilter('saleOrderId', e?.value)}
                  placeholder='ค้นหาด้วย Sale Order'
                />
              </div>
              {/* end:: Sale Order */}

              {/* begin:: Division */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อหน่วยงาน</div>

                <input
                  className='form-control form-control-sm'
                  type='text'
                  value={filter.division}
                  onChange={(e: any) => onChangeFilter('division', e.target.value)}
                  placeholder='ค้นหาด้วยชื่อหน่วยงาน'
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_shipping_list_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Division */}

              {/* begin:: Requested Date */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>วันที่ส่ง</div>

                <Datetime
                  locale='en'
                  dateFormat='DD/MM/YYYY'
                  timeFormat={'HH:mm'}
                  inputProps={{
                    placeholder: 'ค้นหาด้วยวันที่เวลาที่ส่ง',
                  }}
                  renderInput={props => {
                    return <input {...props} autoComplete='off' />
                  }}
                  closeOnClickOutside
                  value={filter.shippingDate}
                  onChange={(e: any) => onChangeFilter('shippingDate', e)}
                  className='filter-date-input w-100'
                />
              </div>
              {/* end:: Requested Date */}

              <div className='col-12 d-flex flex-row'>
                <button
                  className='btn btn-sm btn-primary me-4 w-50 fw-bold'
                  id='kt_shipping_list_filter_close'
                  onClick={onSubmit}>
                  ค้นหา
                </button>
                <button
                  className='btn btn-sm btn-danger w-50 fw-bold'
                  id='kt_shipping_list_filter_close'
                  onClick={onClearFilter}>
                  ล้างค่า
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
